import http from "../http";
import { maskPhone, maskEmail } from "../utils/dataMasking";
import { getDeviceInfo } from "./deviceService";
import { getIPAddress } from "./ipService";
import { AUTH_ENDPOINT, AUTH_GENERATE, AUTH_VALIDATE } from "../http/base-urls";

export async function authenticate(number, password) {
  const data = {
    Numero: number,
    Senha: password,
  };

  try {
    const response = await http.post(AUTH_ENDPOINT, data);
    return response.status === 200;
  } catch (error) {
    throw new Error(msg);
  }
}

export async function getUserContactAync(number, password) {
  const data = {
    Numero: number,
    Senha: password,
  };

  try {
    const response = await http.post(AUTH_ENDPOINT, data);
    return {
      email: response.data.Email,
      emailMask: maskEmail(response.data.Email),
      phone: response.data.Celular,
      phoneMask: maskPhone(response.data.Celular),
    };
  } catch (error) {
    let msg = "";
    if (error.response.status === 404) {
      msg = "Número de protocolo ou senha inválido.";
    } else {
      msg = "Erro no servidor, tente mais tarde.";
    }

    throw new Error(msg);
  }
}

export async function sendSecurityCodeAsync(
  contactMethod,
  serviceIdentfierNumber,
  destination
) {
  try {
    const data = await buildDataAsync(
      contactMethod,
      serviceIdentfierNumber,
      destination
    );

    const response = await http.post(AUTH_GENERATE, data);

    if (response.status != 200) {
      throw new Error("Não foi possível enviar o código de segurança.");
    }
  } catch (error) {
    throw new Error("Não foi possível enviar o código de segurança.");
  }
}

export async function validateSecurityCodeAsync(
  pinCode,
  serviceIdentfierNumber
) {
  const data = await buidlDataCodeAsync(pinCode, serviceIdentfierNumber);

  try {
    const response = await http.post(AUTH_VALIDATE, data);
    return response.status === 200;
  } catch (error) {
    return false;
  }
}

async function buildDataAsync(
  contactMethod,
  serviceIdentfierNumber,
  destination
) {
  return {
    Aplicacao: "PORTAL_LAUDOS",
    Contexto: "ACESSO",
    Chave: serviceIdentfierNumber,
    CanalEnvio: contactMethod,
    Destinatario: destination,
    DadosDispositivo: {
      IP: await getIPAddress(),
      InfoDispositivo: getDeviceInfo(),
    },
  };
}

async function buidlDataCodeAsync(pinCode, serviceIdentfierNumber) {
  return {
    Aplicacao: "PORTAL_LAUDOS",
    Contexto: "ACESSO",
    Chave: serviceIdentfierNumber,
    Codigo: pinCode,
    DadosDispositivo: {
      IP: await getIPAddress(),
      InfoDispositivo: getDeviceInfo(),
    },
  };
}
